<div class="d-flex flex-column pt-2x pb-4x px-6x">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <div>
      <h1 [ngClass]="{ 'd-none': !isDashboardUrl() }">
        {{ 'dashboard.header.home' | translate }}
      </h1>
      <tqc-breadcrumbs
        [ngClass]="{ 'd-none': isDashboardUrl() }"
      ></tqc-breadcrumbs>
    </div>
    <div class="d-flex flex-row align-items-center">
      @if (isDashboardUrl()) {
        @if (hasDamageEntryAccess()) {
          <button
            ds-button
            class="text-uppercase"
            [size]="'md'"
            [routerLink]="['/damages']"
          >
            {{ 'dashboard.header.damageEntry' | translate }}
          </button>
        }
        <button
          ds-button
          class="text-uppercase ms-4x"
          [size]="'md'"
          [variant]="'outline'"
          [routerLink]="['vehicleMovements']"
        >
          {{ 'dashboard.header.vehicleMovements' | translate }}
        </button>
        <button
          ds-button
          class="text-uppercase ms-4x"
          [size]="'md'"
          [variant]="'outline'"
          (click)="openModal()"
        >
          {{ 'dashboard.header.helpDocuments' | translate }}
        </button>
        <button
          [disabled]="true"
          ds-button
          class="ms-4x"
          [size]="'md'"
          [variant]="'outline'"
        >
          {{ 'dashboard.header.faqs' | translate }}
        </button>
      }
      <div class="d-flex gap-2x align-items-center">
        <tqc-switch-country [size]="'md'" class="ms-4x"></tqc-switch-country>
        <tqc-switch-language [size]="'md'" class="ms-4x"></tqc-switch-language>
      </div>
    </div>
  </div>
  @if (isImpersonating() && impersonatedUserName()) {
    <div class="d-flex align-items-center justify-content-end mt-2x">
      <ds-message
        tone="info"
        variant="slim"
        [messageText]="impersonationMessage()"
      ></ds-message>
    </div>
  }
  @if (isDashboardUrl()) {
    <div
      class="d-flex flex-row justify-content-between align-items-center mt-4x"
    >
      <p>{{ 'dashboard.header.hello' | translate }} {{ userFirstName() }}!</p>
      <div class="w-25">
        <tqc-vin17-search
          [placeholder]="('dashboard.header.searchByVIN' | translate) + '...'"
          [globalSearch]="true"
          (vinFound)="navigateToVin($event)"
        />
      </div>
    </div>
  }
</div>

<tqc-ds-modal-wrapper
  [isModalOpen]="isHelpDocumentsModalOpen()"
  (isModalOpenChange)="isHelpDocumentsModalOpen.set($event)"
>
  <span class="tqc-ds-modal-header">
    {{ 'header.modals.helpDocuments.title' | translate }}
  </span>
  <span class="tqc-ds-modal-body" ds-loading-area-container>
    @if (isHelpDocumentsModalOpen()) {
      <tqc-common-table
        [showTitle]="false"
        [showExportButton]="false"
        [showBulkDeleteButton]="false"
        [showActionsColumn]="false"
        [enableFiltering]="false"
        [pagination]="true"
        [paginationPageSize]="25"
        [columnDefs]="columnDefinition()"
        [rowData]="helpDocuments()"
        [rowSelection]="undefined"
        [tableElevation]="'none'"
        [removeBackground]="true"
        [tableHeight]="'50vh'"
      ></tqc-common-table>
    }
  </span>
</tqc-ds-modal-wrapper>
